import { render, staticRenderFns } from "./editad.vue?vue&type=template&id=4bc83d5e&scoped=true&"
import script from "./editad.vue?vue&type=script&lang=js&"
export * from "./editad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc83d5e",
  null
  
)

export default component.exports